import React from 'react'
import { min } from 'lodash'
import B2BButton from '../../components/common/B2BButton'

const AddBrand = ({ modalContent, onClose, saveData, handleModalChange, openSeason }) => {
    return (
        <form onSubmit={(e) => saveData(e, modalContent?.title)} className='form-layout'>
            {/* <h3>{modalContent?.id ? 'Update' : 'Create'} {modalContent.title}</h3> */}
            <div className='layout-fields'>
                <label className='layout-fields-label'>Name</label>
                <input
                    value={modalContent?.name || ''}
                    className='layout-fields-input'
                    required
                    type="text"
                    onChange={(event) => handleModalChange(event, 'name')}
                    placeholder={`${modalContent?.title} Name`}
                />
            </div>
            {openSeason &&
                <>
                    <div className='layout-fields'>
                        <label className='layout-fields-label'>{"Season Code"}</label>
                        <input
                            value={modalContent?.seasonCode?.toUpperCase()}
                            className='layout-fields-input'
                            onChange={(event) => handleModalChange(event, "seasonCode")}
                            required={true}
                            placeholder="Season Code"
                        />
                    </div>

                    <div className='layout-fields'>
                        <label className='layout-fields-label'>{"From Date"}</label>
                        <B2BDateInput
                            value={modalContent.fromDate}
                            onChange={(event) => handleModalChange(event, "fromDate")}
                        />
                    </div>
                    <div className='layout-fields'>
                        <label className='layout-fields-label'>{"To Date"}</label>
                        <B2BDateInput
                            value={modalContent.toDate}
                            onChange={(event) => handleModalChange(event, "toDate")}
                        />
                    </div>
                </>
            }
            <div className='layout-fields'>
                <label className='layout-fields-label'>Status</label>
                <div className='layout-fields-status-input'>
                    <div className='layout-fields-status-radio'>
                        <input
                            type="radio"
                            value="ACTIVE"
                            onChange={(event) => handleModalChange(event, 'status')}
                            checked={modalContent?.status === "ACTIVE"}
                            name="status"
                            id="status-active"
                        />
                        <label className='form-span radio' htmlFor="status-active">ACTIVE</label>
                    </div>
                    <div className='layout-fields-status-radio'>
                        <input
                            type="radio"
                            value="INACTIVE"
                            onChange={(event) => handleModalChange(event, 'status')}
                            checked={modalContent?.status === "INACTIVE"}
                            name="status"
                            id="status-inactive"
                        />
                        <label className='form-span radio' htmlFor="status-inactive">INACTIVE</label>
                    </div>
                </div>
            </div>
            <div className='layout-fields-btn'>
                <B2BButton type='button' onClick={onClose} color={'red'} name="Cancel" />
                <B2BButton type='submit' name={modalContent?.id ? 'Update' : "Save"} />
            </div>
        </form>
    )
}

export default AddBrand